import React, { useState } from "react";

const CountrySwitch = ({ onSwitch }) => {
  const [selectedCountry, setSelectedCountry] = useState("Kuwait");

  const toggleCountry = () => {
    const newCountry = selectedCountry === "Kuwait" ? "India" : "Kuwait";
    setSelectedCountry(newCountry);
    onSwitch(newCountry);
  };

  return (
    <div className="flex items-center space-x-4">
      <span
        className={`text-sm ${
          selectedCountry === "Kuwait" ? "text-blue-500" : "text-gray-500"
        }`}
      >
        Kuwait
      </span>
      <div
        className={`w-14 h-5 flex items-center bg-gray-300 rounded-full p-1 cursor-pointer ${
          selectedCountry === "India" ? "bg-green-500" : "bg-blue-500"
        }`}
        onClick={toggleCountry}
      >
        <div
          className={`bg-white w-3 h-3 rounded-full shadow-md transform ${
            selectedCountry === "India" ? "translate-x-9" : ""
          } transition-transform duration-300`}
        ></div>
      </div>
      <span
        className={`text-sm ${
          selectedCountry === "India" ? "text-green-500" : "text-gray-500"
        }`}
      >
        India
      </span>
    </div>
  );
};

export default CountrySwitch;
